import { render } from "./ModalProductBarcode.vue?vue&type=template&id=af804b6a"
import script from "./ModalProductBarcode.vue?vue&type=script&lang=js"
export * from "./ModalProductBarcode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__